import React from "react";
import {HelpFile} from "../../../model";
import {ColumnDef} from "@tanstack/react-table";
import { DateCell} from "../../../component/list/cell";
import {EntityListTemplate} from "../../../component/template/EntityListTemplate";
import {HelpFileRepository} from "../../../repository";

export const ListHelpFile = () => {

    const columns: ColumnDef<HelpFile>[] = [
        {
            header: "Nom",
            accessorKey: 'name',
            id: 'name',
        },
        {
            header: 'Type',
            accessorKey: 'type',
            id: 'type',
        },
        {
            header: "Permission",
            accessorFn: (data: HelpFile) => data.permission?.length > 0 ? data.permission : 'Accès libre',
            id: 'permission',
        },
        {
            header: 'Version',
            accessorKey: 'version',
            id: 'version',
        },
        {
            header: `Répertoire`,
            accessorKey: 'directory.name',
            id: 'directory.name'
        },
        {
            header: `Dernière mise à jour`,
            accessorKey: `updatedAt`,
            id: `updatedAt`,
            cell: DateCell
        }
    ]

    return (
        <EntityListTemplate<HelpFile>
            repository={new HelpFileRepository()}
            title={`Document (Aide en ligne)`}
            columns={columns}
            rearrangeable
        />
    )
}